var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.scores),function(scr,index){return _c('div',{key:index,staticClass:"mb-2"},[_c('h4',[_vm._v(_vm._s(scr.text))]),_c('b-progress',{attrs:{"max":100,"value":scr.value,"height":"2rem","show-value":"","variant":_vm.getScoreColor(scr.value)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }